import { createGtm } from "@gtm-support/vue-gtm";
import * as Sentry from "@sentry/vue";
import { createPinia } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";
import { createApp } from "vue";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import { parse, stringify } from "zipson";

import "./style.css";

import { initializeAuth } from "@/core/auth/auth-init";

initializeAuth();

import App from "./App.vue";
import router from "./router";

const app = createApp(App);

Sentry.init({
	app,
	dsn: import.meta.env.VITE_SENTRY_DSN,
	integrations: [
		Sentry.browserTracingIntegration({ router }),
		Sentry.browserProfilingIntegration(),
	],
	tracesSampleRate: 0.1,
	profilesSampleRate: 1.0,
	beforeSend(event) {
		if (event.level === "info") {
			return null;
		}
		return event;
	},
});

const store = createPinia();
store.use(
	createPersistedState({
		debug: true,
		serializer: {
			deserialize: parse,
			serialize: stringify,
		},
	}),
);
app.use(store);

app.use(Toast, {
	maxToasts: 5,
	newestOnTop: true,
	position: POSITION.TOP_CENTER,
	hideProgressBar: true,
	closeButton: false,
	timeout: 3000,
});

app.use(
	createGtm({
		id: import.meta.env.VITE_GTM_ID,
		enabled: true,
		debug: import.meta.env.DEV,
		defer: true,
		vueRouter: router,
		loadScript: true,
	}),
);

app.use(router);
app.mount("#app");
